export const DENOMINATIONS = [
	{key: '100', label: '$100'},
	{key: '50', label: '$50'},
	{key: '20', label: '$20'},
	{key: '10', label: '$10'},
	{key: '5', label: '$5'},
	{key: '2', label: '$2'},
	{key: '1', label: '$1'},
	{key: '0.5', label: '50\u00A2'},
	{key: '0.25', label: '25\u00A2'},
	{key: '0.1', label: '10\u00A2'},
	{key: '0.05', label: '5\u00A2'},
	{key: '0.01', label: '1\u00A2'},
];

export function emptyDenomCounts() {
	const counts = {};
	DENOMINATIONS.forEach(d => {
		counts[d.key] = '0';
	});
	return counts;
}

export function parseDenominations(json) {
	const counts = emptyDenomCounts();
	if (!json) {
		return counts;
	}
	try {
		const data = typeof json === 'string' ? JSON.parse(json) : json;
		DENOMINATIONS.forEach(d => {
			if (data[d.key] != null && data[d.key] !== '') {
				counts[d.key] = String(data[d.key]);
			}
		});
		return counts;
	} catch (e) {
		return counts;
	}
}

export function buildDenomPayload(counts) {
	const payload = {};
	DENOMINATIONS.forEach(d => {
		const c = parseInt(counts[d.key], 10);
		if (!Number.isNaN(c) && c > 0) {
			payload[d.key] = c;
		}
	});
	return payload;
}

export function computeCounted(counts) {
	let total = 0;
	DENOMINATIONS.forEach(d => {
		const c = parseInt(counts[d.key], 10);
		if (!Number.isNaN(c) && c > 0) {
			total += parseFloat(d.key) * c;
		}
	});
	return Math.round(total * 100) / 100;
}

export function formatCashLeftDenomMismatchMessage(difference) {
	const abs = Math.round(Math.abs(difference) * 100) / 100;
	if (abs < 0.005) {
		return null;
	}
	const formatted = abs.toFixed(2);
	if (difference > 0) {
		return `$${formatted} more cash in drawer than denomination count`;
	}
	return `$${formatted} less cash in drawer than denomination count`;
}

export function getCashLeftDenomMismatch(cashLeftRaw, denomCounts) {
	const cashLeft = parseFloat(cashLeftRaw);
	if (Number.isNaN(cashLeft)) {
		return null;
	}
	const denomTotal = computeCounted(denomCounts || {});
	const difference = Math.round((cashLeft - denomTotal) * 100) / 100;
	const message = formatCashLeftDenomMismatchMessage(difference);
	if (!message) {
		return null;
	}
	return {
		difference,
		denomTotal,
		cashLeft,
		message,
		noteSuffix: `(${message})`,
	};
}

export function appendCashLeftDenomMismatchNote(userNote, mismatch) {
	if (!mismatch?.noteSuffix) {
		return String(userNote || '').trim();
	}
	const trimmed = String(userNote || '').trim();
	if (trimmed.includes(mismatch.noteSuffix)) {
		return trimmed;
	}
	if (/cash in drawer than denomination count/i.test(trimmed)) {
		return trimmed;
	}
	return trimmed ? `${trimmed} ${mismatch.noteSuffix}` : mismatch.noteSuffix;
}

export function formatMoney(value) {
	const parsed = parseFloat(value);
	if (Number.isNaN(parsed)) {
		return '0.00';
	}
	return parsed.toFixed(2);
}

export function parseCustomizationBool(value, defaultValue = false) {
	if (value === null || value === undefined) {
		return defaultValue;
	}
	if (typeof value === 'boolean') {
		return value;
	}
	if (typeof value === 'number') {
		return value !== 0;
	}
	if (typeof value === 'string') {
		const normalized = value.trim().toLowerCase();
		if (normalized === '0' || normalized === 'false') {
			return false;
		}
		if (normalized === '1' || normalized === 'true') {
			return true;
		}
	}
	return !!value;
}
